import React from "react";
import PropTypes from "prop-types";
import RModal from "react-modal";

function Modal(props) {
  const { children, isOpen, onRequestClose, maxWidth } = props;

  return (
    <RModal
      ariaHideApp={false}
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      style={{
        overlay: {
          backgroundColor: "rgba(0,15,50,0.3)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
        content: {
          inset: "unset",
          padding: 0,
          boxShadow: "rgb(0 0 0 / 20%) 0px 1px 1.41px",
          borderRadius: "4px",
          border: "none",
          maxWidth: `${maxWidth}px`,
          width: "100%",
          maxHeight: "90vh",
          overflowY: "auto",
        },
      }}>
      {children}
    </RModal>
  );
}

Modal.propTypes = {
  children: PropTypes.any.isRequired,
  isOpen: PropTypes.bool,
  onRequestClose: PropTypes.func,
  maxWidth: PropTypes.number,
};

Modal.defaultProps = {
  isOpen: false,
  maxWidth: 450,
};

export default React.memo(Modal);
